import { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'conv... Remove this comment to see the full error message
import { createCaptureOnceForKey } from 'conversations-thread-view/unified-thread-history/components/UnifiedThreadHistory';
import { clearPerformanceMarksAndMeasures } from 'conversations-thread-view/performance-metrics/operators/gatherPerformanceMetrics';
import { addThreadListMemberToBatchGroup, removeThreadListMemberFromBatchGroup } from '../actions/threadListMemberBatchUpdatesActions';
import { useIsBulkUpdated } from 'find-and-filter-data/bulk-operations/public';
import { makeGetIsInBatchUpdatesList, getBatchThreadCount } from '../selectors/threadListMembersBatchUpdatesSelectors';
import { makeGetPublishFailedForThreadListMember } from '../../pubsub/selectors/getPublishFailedForThreadListMember';
import { getOpenedThread } from 'conversations-inbox-lib/usage-tracking/inboxInteractionEvents';
import { MAX_THREAD_COUNT } from '../../batch-thread-operations-toolbar/constants/maxThreadCount';
import { THREAD_SWITCHING_MARKER, UNIVERSAL_SIDEBAR_MARKERS } from '../../performance-metrics/constants/performanceConstants';
import { trackEvent } from '../../usage-tracking/clients/usageTracker';
import { useCurrentView } from '../../custom-views/hooks/useCurrentView';
import { getViewOrderedBy } from 'find-and-filter-data/views-schema/public';
import { isInSearchAndFilterMode as getIsInSearchAndFilterMode } from 'conversations-inbox-lib/thread-search-and-filtering/public/selectors';
import PreviewCard from '../../preview-card/components/PreviewCard';
import { getUserId } from '../../selectors/userSelectors/getUserId';
import { getThreadListMemberWithFirstSLAIndicator } from '../selectors/getThreadListMemberWithFirstSLAIndicator';
import { dismissInboxSLATourPopover, viewInboxSLATourPopover } from '../../sla-onboarding/constants/Events';
import { getActiveSLA, getGenericChannel, getHasAssociatedTickets } from 'find-and-filter-data/view-members-schema/protected';
import { getViewMemberId, isMemberSeen } from 'find-and-filter-data/view-members-schema/public';
import { hasSLAAlertsAccess } from '../../selectors/userSelectors/hasSLAAlertsAccess';
import { EERIE, HEFFALUMP } from 'HubStyleTokens/colors';
import UIIcon from 'UIComponents/icon/UIIcon';
import { getIsUngatedForLimitedTicketFunctionality } from '../../selectors/gateSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
const limitToOncePerThreadId = createCaptureOnceForKey();

// being exported for unit testing
export const __useThreadListMemberRowContainer = ({
  index,
  onSelectThread,
  selected,
  threadListMember
}) => {
  const hasAttachedSLA = !!getActiveSLA(threadListMember);
  const threadId = +getViewMemberId(threadListMember);
  const dispatch = useDispatch();
  const batchThreadCount = useSelector(getBatchThreadCount);
  const getIsInBatchUpdatesList = useMemo(makeGetIsInBatchUpdatesList, []);
  const getPublishFailedForThreadListMember = useMemo(makeGetPublishFailedForThreadListMember, []);
  const hasBeenBatchUpdated = useIsBulkUpdated(threadId);
  const isInBatchUpdatesList = useSelector(state => getIsInBatchUpdatesList(state, {
    threadListMember
  }));
  const publishFailed = useSelector(state => getPublishFailedForThreadListMember(state, {
    threadListMember
  }));
  const isInSearchAndFilteringMode = useSelector(getIsInSearchAndFilterMode);
  const currentView = useCurrentView();
  const threadListOrderBy = getViewOrderedBy(
  // if in search and filter mode, use default view order by value
  isInSearchAndFilteringMode ? null : currentView);
  const channel = getGenericChannel(threadListMember);

  //Add the initial focused thread's ID to the cache so that we don't calculate
  //the time it takes to load cached thread details if the user navigates
  //away and back to the initial thread.
  if (selected) limitToOncePerThreadId(threadId, () => {});
  const handleThreadListMemberClick = useCallback(() => {
    if (!hasBeenBatchUpdated && !selected) {
      limitToOncePerThreadId(threadId, () => {
        performance.mark(`${THREAD_SWITCHING_MARKER}-start-${threadId}`);
        if (!isInSearchAndFilteringMode) {
          for (const markerKey of Object.keys(UNIVERSAL_SIDEBAR_MARKERS)) {
            // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
            const marker = UNIVERSAL_SIDEBAR_MARKERS[markerKey];
            clearPerformanceMarksAndMeasures(marker);
            performance.mark(`${marker}-start`);
          }
        }
      });
      if (onSelectThread) onSelectThread({
        threadId
      });
      trackEvent(getOpenedThread({
        index: index + 1,
        isFiltering: isInSearchAndFilteringMode,
        isSearching: isInSearchAndFilteringMode,
        channel,
        hasAttachedSLA
      }));
    }
  }, [hasBeenBatchUpdated, index, isInSearchAndFilteringMode, onSelectThread, selected, threadId, channel, hasAttachedSLA]);
  const handleBatchUpdatesChange = useCallback(() => {
    if (!isInBatchUpdatesList) {
      return batchThreadCount < MAX_THREAD_COUNT && dispatch(addThreadListMemberToBatchGroup(threadId));
    }
    return dispatch(removeThreadListMemberFromBatchGroup(threadId));
  }, [isInBatchUpdatesList, batchThreadCount, threadId, dispatch]);
  return {
    batchThreadCount,
    hasBeenBatchUpdated,
    isInBatchUpdatesList,
    handleThreadListMemberClick,
    handleBatchUpdatesChange,
    publishFailed,
    renderAbsoluteTimestampOverride: isInSearchAndFilteringMode,
    threadListOrderBy
  };
};
const ThreadListMemberRowContainer = ({
  index,
  onSelectThread,
  selected,
  threadListMember
}) => {
  const {
    batchThreadCount,
    hasBeenBatchUpdated,
    isInBatchUpdatesList,
    handleThreadListMemberClick,
    handleBatchUpdatesChange,
    publishFailed,
    renderAbsoluteTimestampOverride,
    threadListOrderBy
  } = __useThreadListMemberRowContainer({
    index,
    onSelectThread,
    selected,
    threadListMember
  });
  const userId = useSelector(getUserId);
  const threadListMemberWithFirstSLAIndicator = useSelector(getThreadListMemberWithFirstSLAIndicator);
  const showInboxSLATour = Boolean(threadListMemberWithFirstSLAIndicator && threadListMember && getViewMemberId(threadListMemberWithFirstSLAIndicator) === getViewMemberId(threadListMember));
  const onInboxSLATourOpen = useCallback(() => {
    return trackEvent(viewInboxSLATourPopover());
  }, []);
  const onInboxSLATourClose = useCallback(() => {
    return trackEvent(dismissInboxSLATourPopover());
  }, []);
  const shouldLimitTicketFunctionality = useSelector(getIsUngatedForLimitedTicketFunctionality);
  const ticketIcon = !shouldLimitTicketFunctionality && getHasAssociatedTickets(threadListMember) ? /*#__PURE__*/_jsx(UIIcon, {
    color: !isMemberSeen(threadListMember, userId) ? HEFFALUMP : EERIE,
    name: "ticket",
    size: "xxs"
  }) : undefined;
  return /*#__PURE__*/_jsx(PreviewCard, {
    hasSLAAlertsAccess: useSelector(hasSLAAlertsAccess),
    bottomLeftIcon: ticketIcon,
    disabled: hasBeenBatchUpdated,
    isSelected: selected,
    isUnread: !isMemberSeen(threadListMember, userId),
    member: threadListMember,
    handleClick: handleThreadListMemberClick,
    publishFailed: publishFailed,
    viewOrderBy: threadListOrderBy,
    renderAbsoluteTimestampOverride: renderAbsoluteTimestampOverride,
    disableBulkSelect: batchThreadCount >= MAX_THREAD_COUNT,
    handleBatchUpdatesChange: handleBatchUpdatesChange,
    isBulkSelected: isInBatchUpdatesList,
    showInboxSLATour: showInboxSLATour,
    onInboxSLATourOpen: onInboxSLATourOpen,
    onInboxSLATourClose: onInboxSLATourClose,
    shouldDisableSLA: shouldLimitTicketFunctionality
  });
};
ThreadListMemberRowContainer.displayName = 'ThreadListMemberRowContainer';
export default ThreadListMemberRowContainer;